import { render, staticRenderFns } from "./Temp.vue?vue&type=template&id=07620bfd&"
import script from "./Temp.vue?vue&type=script&lang=js&"
export * from "./Temp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports